import ReportDetail from '@/shared/publish/MyPublications/ReportDetail/'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/MyPublications/ReportDetail/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ReportDetail />
}
